module.exports = __webpack_public_path__ + "media/components/icons/arrow-down-69ed5bffd95f8c59d1bf32cb9b296bd5.svg";